/*
 * Module for one lonesome report
 */

//DataModel imported because we reqres it
define([
  "marionette",
  "backbone",
  "highcharts/highcharts",
  "jquery",
  "messaging/messenger",
  "modules/reportSplit/reports/singleReport/reportUtilities",
  "modules/shared/surveyComments/surveyCommentsModule",
  "modules/reportSplit/reports/reportModel",
  "moment",
], function (
  Marionette,
  Backbone,
  Highcharts,
  $,
  Messenger,
  ReportUtilities,
  SurveyCommentsModule,
) {
  "use strict";

  const BarChartShow = function (report, renderTo, singleReportModule) {
    const clickAction = _clickActionAction(report);

    if (report.type === "bar") {
      let notSpecified = "";
      if (report.options.title === undefined) {
        notSpecified = "\nreport.options.title";
      }
      if (report.options.xAxisTitle === undefined) {
        notSpecified = notSpecified + "\nxAxisTitle";
      }
      if (report.options.yAxisTitle === undefined) {
        notSpecified = notSpecified + "\nyAxisTitle";
      }
      if (notSpecified !== "") {
        Messenger.okDialog(
          "The following report options are required for line charts, but were not specified:\n" +
            notSpecified +
            "\n\nThey must be added to the report when it is created on the server.  The report will not be able to display until they are added.",
        );
        return;
      }
      /**
       * This report is more like what one of our real reports will look like, despite it being a made-up report.
       * The reqres call below retieves the data that will be displayed in HighCharts (assigned in the series
       * below).
       *
       * The handler for the reqres calls for dataSets should be placed in dataModel.js to keep them all together;
       * you can find this one by searching for "lineChartData" in dataModel.js.  The same reqres call can be used
       * by other charts that are line charts.
       */
      let dataSet = Messenger.reqres.request("barChartData", report.href);
      console.log(dataSet);
      /**
       * Ths .once("sync" code here is very important.  This waits for the data to be retrieved from the web server
       * before doing what is inside of it (which is displaying the HighChart).  If this weren't here, we'd wind up
       * with charts that showed nothing because they would be drawn before the data for them arrived.
       */
      singleReportModule.listenTo(
        dataSet,
        "sync",
        function () {
          //dataSet.once("sync", function() {
          //show the single report layout
          singleReportModule.showRegion(singleReportModule.layout);
          Messenger.vent.trigger("report:arrived", report);
          console.log(dataSet);
          /**
           * Retrieve the parameters that the user gave for the configuration.
           */
          let currentTitle;
          if (dataSet.get("customTitle")) {
            currentTitle = $.t(dataSet.get("customTitle"));
          } else {
            currentTitle = $.t(report.options.title);
            currentTitle = ReportUtilities.figureOutText(currentTitle, true);
          }
          let xAxisTitle = "X Axis";
          if (dataSet.get("customXAxis")) {
            xAxisTitle = $.t(dataSet.get("customXAxis"));
          } else {
            xAxisTitle = $.t(report.options.xAxisTitle);
          }
          const yAxisTitle = $.t(report.options.yAxisTitle);

          let subTitleText = null;
          if (report.options.subTitle) {
            subTitleText = $.t(report.options.subTitle);
          }
          if (subTitleText !== null) {
            subTitleText = ReportUtilities.figureOutText(subTitleText, true);
          }
          /**
           * The data comes back as (usually) a Backbone collection.  This works well for retrieving it from the
           * RESTful service on this web server, and generally we'll want to keep it in this format.  However,
           * HighCharts needs it in JSON format to display the chart.  We can get this by simply calling the
           * .toJSON() method on it.  JSON.stringify(dataSet) should also work.
           */
          dataSet = dataSet.toJSON();
          //post-processing
          for (let i = 0; i < dataSet.categories.length; i++) {
            if (report.type === "stackedColumn") {
              if (
                report.href.startsWith("/topicDetail") &&
                Messenger.reqres.request("param:{interval}", "{interval}", 2) === "Daily"
              ) {
                //convert it into a date format
                dataSet.categories[i] = Messenger.reqres.request(
                  "get:formatted:date",
                  dataSet.categories[i].value,
                );
              } else {
                dataSet.categories[i].value = $.t(dataSet.categories[i].value);
              }
              const suffix = dataSet.categories[i].suffix;
              if (suffix) {
                dataSet.categories[i] = dataSet.categories[i].value + " " + suffix;
              } else {
                dataSet.categories[i] = dataSet.categories[i].value;
              }
            } else if (report.type === "bar") {
              if (dataSet.categories[i] === null) {
                dataSet.categories[i] = "";
              }
              dataSet.categories[i] = $.t(dataSet.categories[i]);
            }
          }

          if (report.href.startsWith("/trendingII")) {
            const topicChoicesArray = [];
            for (let i = 0; i < dataSet.categories.length; i++) {
              const id = dataSet.categories[i].substring(dataSet.categories[i].indexOf("|") + 1);
              dataSet.categories[i] = dataSet.categories[i].substring(
                0,
                dataSet.categories[i].indexOf("|"),
              );
              topicChoicesArray[i + 1] = id;
            }
            Messenger.reqres.setHandler(
              "reports:intentID",
              function (intentName) {
                return topicChoicesArray[intentName];
              },
              this,
            );
          }

          if (report.type === "stackedColumn") {
            for (let i = 0; i < dataSet.lines.length; i++) {
              if (dataSet.lines[i].name !== null) {
                dataSet.lines[i].name = $.t(dataSet.lines[i].name);
              } else {
                Messenger.okDialog("this series should have a name");
              } //REMOVE BEFORE RELEASE
            }
          } else if (report.type === "bar") {
            for (let i = 0; i < dataSet.data.length; i++) {
              if (dataSet.data[i].seriesName === null) {
                dataSet.data[i].name = $.t(report.options.seriesTitle);
              } else {
                dataSet.data[i].name = dataSet.data[i].seriesName;
              }
            }
          }
          if (report.href.startsWith("/catWeekGraph")) {
            const touchpoints = Messenger.reqres.request("kb:touchpoints");
            for (let i = 0; i < touchpoints.length; i++) {
              const point = touchpoints.models[i];
              if (point.get("touchPointId") === Number(dataSet.lines[0].name)) {
                dataSet.lines[0].name = point.get("touchPoint");
                break;
              }
            }
            //dataSet.lines[0].name = Messenger.reqres.request("reports:intentName", dataSet.lines[0].name);
          }

          //Set the proper x axis type
          //Not doing this can result in some column labels being left out (if it's always linear), in
          //the case that the distance between the closest two data points is more than one
          //See: http://api.highcharts.com/highcharts#plotOptions.column.pointRange
          //Actually, this doesn't seem to matter; even if it's 'category', that persists.
          //However, setting the point range explicitly fixes the problem
          //We may also be able to use that manually to label, say, every 3 months
          let xAxisType = "linear";
          if (dataSet.categories) {
            xAxisType = "category";
          }

          const checkForData = function (dataSet) {
            for (let i = 0; i < dataSet.data.length; i++) {
              for (let k = 0; k < dataSet.data[i].data.length; k++) {
                if (report.type === "stackedColumn") {
                  if (dataSet.lines[i].data[k].y !== 0 && dataSet.lines[i].data[k].y !== null) {
                    return true;
                  }
                } else if (report.type === "bar") {
                  if (dataSet.data[i].data[k] !== 0 && dataSet.data[i].data[k] !== null) {
                    return true;
                  }
                }
              }
            }
            return false;
          };

          const hasData = checkForData(dataSet);
          //hasData ? alert(currentTitle + " has Data"):alert(currentTitle + " has No Data");
          if (!hasData) {
            subTitleText = $.t("reports.noData.long");
          }

          const type =
            report.type === "stackedColumn"
              ? "column"
              : report.type === "bar"
                ? "bar"
                : Messenger.okDialog("invalid chart type");
          $(function () {
            singleReportModule.createChart({
              chart: {
                type: type,
              },
              title: {
                text: currentTitle,
              },
              subtitle: {
                text: subTitleText,
              },
              xAxis: {
                type: xAxisType,
                title: {
                  text: xAxisTitle,
                },
                labels: {
                  formatter: function () {
                    return this.value; //this prevents HighCharts from adding a comma for readability.  since this is
                    // a year, we don't want that comma
                  },
                },
                categories: dataSet.categories,

                //optionally could also have gridLineWidth: 1
              },
              yAxis: {
                title: {
                  text: yAxisTitle,
                },
                startOnTick: false,
                allowDecimals: false,
              },
              plotOptions: {
                column: {
                  stacking: "normal",
                  pointRange: 1,
                  point: {
                    events: {
                      click: function () {
                        if (clickAction === null) {
                          //no drilldown; return rather than throwing a NullPointerException
                          return;
                        }
                        const whatever = this.category;
                        clickAction(whatever, this.category);
                      },
                    },
                  },
                },
                bar: {
                  stacking: "normal",
                  point: {
                    events: {
                      click: function () {
                        if (clickAction === null) {
                          //no drilldown; return rather than throwing a NullPointerException
                          return;
                        }
                        clickAction(this.x + 1, this.category);
                      },
                    },
                  },
                },
              },
              /**
               * At this point the dataSet is already in a format the covers all of the serieses
               */
              series: dataSet.data,
            });
          });
        },
        this,
      );
    }
  };

  function _clickActionAction(report) {
    let clickAction = null;

    //report-specific stuff
    if (report.href.startsWith("/accuracyDistribution/")) {
      clickAction = function (category) {
        /**
         * Parameter setup.  The Escalation Topic report needs to know which channel you want topics for - it's a
         * parameter. So, we need to set a handler for the topic here. Note that this handler isn't cleared
         * explicitly.  Rather, when the report area view is closed (which it is when a new report is shown), this
         * is cleaned up.  Although I'm not 100% sure that this will work with multiple drilldown - I'll find that
         * out fairly soon.
         */
        Messenger.vent.trigger("set:parameter", "bucket", category);
        /**
         * Another attribute of the dataSet for the pieChart reqres is the drillDownReport (which we get from the
         * reportModel).  Here, we retrieve that.
         */
        const ddReport = report.drillDownReport;
        /**
         * If a drilldown exists (which is should), we send out an event to show a new report.  "show:report" will
         * re-route back to the top of this showReport method, with the new report to show as the first parameter.
         * We also send the leaveExistingConfig view parameter as true (since later on, we won't want drilling down
         * to wipe out config settings).  The last parameter being true is really confusing right now and I need to
         * refactor that.  For now, setting it as true makes the drilldown show up.
         */
        if (ddReport) {
          for (let c = 0; c < ddReport.length; c++) {
            const currentDrillDown = ddReport[c];
            Messenger.vent.trigger("show:drilldown", currentDrillDown);
          }
        }
      };
    } else if (report.href.startsWith("/trendingII/")) {
      clickAction = function (category) {
        //If the user is an author, go to that topic
        const canAuthor = Messenger.reqres.request("user:is:author");
        if (canAuthor) {
          let intentID = Messenger.reqres.request("reports:intentID", category);
          if (intentID === null) {
            intentID = category;
          }
          const kbId = Messenger.reqres.request("active:kb");
          Backbone.history.navigate(kbId + "/topic/" + intentID, { trigger: true });
        }
      };
    } else if (report.href.startsWith("/surveyReport/")) {
      clickAction = function (category, displayName) {
        Messenger.vent.trigger("set:parameter", "surveyChoice", category);
        Messenger.vent.trigger("set:parameter", "surveyChoiceDisplay", displayName);

        const ddReport = report.drillDownReport;
        /**
         * If a drilldown exists (which is should), we send out an event to show a new report.  "show:report" will
         * re-route back to the top of this showReport method, with the new report to show as the first parameter.
         * We also send the leaveExistingConfig view parameter as true (since later on, we won't want drilling down
         * to wipe out config settings).  The last parameter being true is really confusing right now and I need to
         * refactor that.  For now, setting it as true makes the drilldown show up.
         */
        if (ddReport) {
          for (let c = 0; c < ddReport.length; c++) {
            const currentDrillDown = ddReport[c];
            Messenger.vent.trigger("show:drilldown", currentDrillDown);
          }
        }
      };
    } else if (report.href.startsWith("/topicSurvey/")) {
      const isAuthor = Messenger.reqres.request("user:is:author");

      clickAction = function (category) {
        const configBundle = {
          touchPoints: Messenger.reqres.request("param:{touchpoint}", "{touchpoint}"),
          topicId: Messenger.reqres.request("param:{topic}", "{topic}"),
          language: Messenger.reqres.request("param:{language}", "{language}"),
          startDate: Messenger.reqres.request("param:{startDate}", "{startDate}"),
          endDate: Messenger.reqres.request("param:{endDate}", "{endDate}"),
          surveyChoice: category,
          deleteComments: isAuthor,
        };
        Messenger.vent.trigger("show:modal", SurveyCommentsModule, null, configBundle, {
          title: "reports.surveyDrilldown.comments",
          closeButton: true,
          closeOnBackgroundClick: true,
          modalHeight: "400px",
          trackInteraction: {
            action: "Show Survey Comments",
            object: "Survey Comments",
            source: "Topic Survey Report",
          },
        });
      };
    }
    return clickAction;
  }

  return BarChartShow;
});
